import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

/**
 * TitleUpdater Component - Automatically updates page title based on current route
 * Place this component inside the Router in App.js
 */
const TitleUpdater = () => {
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    // Extract base title from public/index.html once
    const baseTitle = "Student Portfolio Builder";

    // Convert kebab-case/snake_case to Title Case
    const toTitleCase = (str) => {
      return str
        .split(/[-_]/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    // Generate title from path
    const getTitleFromRoute = () => {
      const path = location.pathname;
      
      if (path === '/') return baseTitle;

      // Get everything after the first '/' and convert to title case
      const pathContent = path.substring(1); // Remove leading '/'
      const segments = pathContent.split('/');
      const pageTitle = segments.map(toTitleCase).join(' - ');
      
      return `${pageTitle} - ${baseTitle}`;
    };

    document.title = getTitleFromRoute();
  }, [location, params]);

  return null; // This component doesn't render anything
};

export default TitleUpdater;
